import {Link} from "react-router-dom";

export default function SmallButton({title, to}) {
    return <Link className="font-light" to={to}>
        <div className="button-small font-light text-align-center">
            <div className="button-header-small">{title}</div>
        </div>
    </Link>
}